export default __webpack_public_path__ + "static/media/MG.b98a36fe.ico";